// REACT & REDUX
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistReducer } from 'redux-persist';

// STYLE, PROPS & TRANSLATIONS

// COMMON
import rootReducer from '../reducers';
import storage from 'redux-persist/lib/storage';

// COMPONENTS

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

// PERSISTANCE:
const persistConfig = {
    key: 'root',
    storage,
    blacklist: []
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ENHANCE:
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// CREATE STORE:
export const store = createStore(persistedReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));

